import { clearAllCache as clearCurrentUser } from 'selectors/user/selector';
import { clearAllCache as clearUserName } from 'selectors/formatName/selector';
import { clearAllCache as clearUserNameColor } from 'selectors/nameColor/selector';

export default function clearAll() {
  clearCurrentUser();
  clearUserName();
  clearUserNameColor();
}

export { clearAll };
